<template>
    <div class="chart-card">
        <div class="top"><h2>{{$t('home.entries')}}</h2>

            <span>{{$t('general.salonID')}}: {{salon.sid || $t('general.none')}}</span></div>

        <div class="chart-container">
            <BarChart :chart-data="dataCollection" :options="style" class="chart"></BarChart>
        </div>
    </div>
</template>

<script>
import BarChart from '@/components/charts/BarChart.js';

export default {
  components: {
    BarChart,
  },
  props: {
    salon: {
      type: Object,
      required: true,
    },
    dataCollection: {
      type: Object,
      required: false,
    },
  },
  computed: {
    style() {
      // const height = this.chartData.labels.length * 85;
      const height = 290;
      return {
        maintainAspectRatio: false,
        scales:
          {
            xAxes: [{
              minBarLength: 2,
              gridLines: {
                offsetGridLines: true,
              },
              ticks: {
                beginAtZero: true,
              },
            }],
            yAxes:
              [{
                yAxes: [{
                  barPercentage: 0.95,
                  categoryPercentage: 1.0,
                  beginAtZero: true,
                }],
              }],
          },
        height,
      };
    },

  },
};
</script>

<style lang="scss" scoped>
    .chart-card {
        width: 100%;
        max-height: 382px;
        box-sizing: border-box;
        //overflow-y: scroll;
    }

    .chart-container {
        padding: 30px;
        box-sizing: border-box;
        max-height: 320px;

        /*margin-top: 15px;*/
        .chart {
            height: 230px;
        }
    }

    .top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-right: 30px;
        border-bottom: 1px solid #e5e5e5;
    }

    h2 {
        /* color: #878a94; */
        font-size: rem(18px);
        font-weight: 800;
        text-transform: uppercase;
        text-align: left;
        padding: 29px 26px;
        margin: 0;
    }
</style>
